import styled from 'styled-components';
import BreakPoints from '../../styling/media-queries';
import { PAGE_GUTTER } from './consts';

const FullWidthContainer = styled.div`
  position: relative;
  left: -${PAGE_GUTTER};
  height: 100%;
  width: 100vw;
  @media ${BreakPoints.tablet} {
    margin-bottom: 50px;
    margin-top: 0;
  }
`;

export default FullWidthContainer;



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/containers/FullWidthContainer.tsx